import { RouteConfig } from 'vue-router';

const PAGE_TITLE = '上游新闻有奖问答';

const route: RouteConfig = {
  path: '/2019QuestionMasterSecond',
  name: 'QuestionMasterSecond',
  component: () => import('./Home.vue'),
  redirect: '/2019QuestionMasterSecond/First',
  meta: {
    title: PAGE_TITLE,
  },
  children: [
    {
      path: 'first',
      component: () => import('./First.vue'),
      name: 'first',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'second',
      component: () => import('./Second.vue'),
      name: 'second',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'third',
      component: () => import('./Third.vue'),
      name: 'third',
      meta: {
        title: PAGE_TITLE,
      },
    },
    {
      path: 'fourth',
      component: () => import('./Fourth.vue'),
      name: 'fourth',
      meta: {
        title: PAGE_TITLE,
      },
    },
  ],
};

export default route;
